import {Vue, Component, Inject, Watch} from "vue-property-decorator";
import {AppSettings} from "~/lib/app-settings";
import {getUsersManagementStore} from "~/modules/users/store";
import {PaginationComponent} from "~/components/pagination";

const MAX_PER_PAGE = 50;
const usersManagementStore = getUsersManagementStore();

@Component
export class UsersLoaderMixin extends Vue {

  @Inject() appSettings: AppSettings;

  @usersManagementStore.Action fetchUsers;
  @usersManagementStore.Getter totalUsersFiltered;

  protected textFilter = "";
  protected rolesFilter = null;
  protected groupFilter = null;

  // PageSpecs
  protected pagination = {
    limit: MAX_PER_PAGE,
    offset:0
  };

  @Watch("textFilter")
  @Watch("rolesFilter")
  @Watch("groupFilter")
  async onFiltersChange() {
    this.pagination.offset = 0;
    await this.loadUsers();
  }

  async loadUsers(){
    await this.fetchUsers({
      clientUUID: this.appSettings.clientUUID,
      limit: this.pagination.limit,
      offset: this.pagination.offset,
      textFilter: this.textFilter,
      rolesFilter: this.rolesFilter?.id,
      groupFilter: this.groupFilter?.id
    });
  }

  renderPagination(){
    return (
      <PaginationComponent
        class="m-t-20"
        onChange={ async pagination => {
          this.pagination = pagination;
          await this.loadUsers();
        }}
        value={this.pagination}
        total={this.totalUsersFiltered}
      />
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-165a9ee8/users-loader-mixin.tsx" });